import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  DateField,
  ReferenceField,
  ArrayField,
  Datagrid,
  FunctionField,
  TopToolbar,
  EditButton,
  DeleteButton,
} from 'react-admin';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';

const ShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

const StatusChip = ({ record }: { record: any }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'draft': return 'default';
      case 'sent': return 'info';
      case 'approved': return 'success';
      case 'rejected': return 'error';
      case 'expired': return 'warning';
      default: return 'default';
    }
  };

  return (
    <Chip 
      label={record.status?.toUpperCase() || 'UNKNOWN'} 
      color={getStatusColor(record.status) as any}
      size="small" 
    />
  );
};

export const BillShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Basic Information
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
            <TextField source="billNumber" label="Bill Number" />
            <TextField source="title" />
            <ReferenceField source="customerId" reference="customers" link="show">
              <TextField source="name" />
            </ReferenceField>
            <FunctionField
              source="status"
              label="Status"
              render={(record: any) => <StatusChip record={record} />}
            />
            <DateField source="validUntil" label="Valid Until" />
            <DateField source="createdAt" label="Created" showTime />
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Financial Details
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
            <NumberField source="subtotal" options={{ style: 'currency', currency: 'USD' }} />
            <NumberField source="taxAmount" options={{ style: 'currency', currency: 'USD' }} />
            <NumberField source="totalAmount" options={{ style: 'currency', currency: 'USD' }} />
            <NumberField source="taxRate" options={{ style: 'percent' }} />
          </Box>
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Line Items
          </Typography>
          <ArrayField source="lineItems">
            <Datagrid bulkActionButtons={false}>
              <TextField source="description" />
              <NumberField source="quantity" />
              <NumberField source="unitPrice" options={{ style: 'currency', currency: 'USD' }} />
              <NumberField source="amount" options={{ style: 'currency', currency: 'USD' }} />
            </Datagrid>
          </ArrayField>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Additional Information
          </Typography>
          <TextField source="notes" multiline rows={3} />
          <TextField source="terms" multiline rows={2} />
        </CardContent>
      </Card>
    </SimpleShowLayout>
  </Show>
);